import { Gavel, Ticket } from 'lucide-react';

import { cn } from '../../utils/cn';

export type SessionsTab = 'sessions' | 'tickets' | 'kvalitet';

const tabClass = (active: boolean) =>
  cn(
    'flex items-center gap-1.5 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition',
    active
      ? 'border-brand-blue text-brand-blue'
      : 'border-transparent text-slate-500 hover:text-slate-700',
  );

interface SessionTabsProps {
  active: SessionsTab;
  draftCount: number;
  onSelect: (tab: SessionsTab) => void;
}

export const SessionTabs = ({ active, draftCount, onSelect }: SessionTabsProps) => (
  <div className="flex items-center gap-1 border-b border-slate-200">
    <button
      type="button"
      onClick={() => onSelect('sessions')}
      className={tabClass(active === 'sessions')}
    >
      Sessioner
    </button>
    <button
      type="button"
      onClick={() => onSelect('tickets')}
      className={tabClass(active === 'tickets')}
    >
      <Ticket className="h-4 w-4" />
      Tickets
      {draftCount > 0 && (
        <span className="rounded-full bg-indigo-600 px-1.5 py-0.5 text-[10px] font-semibold text-white">
          {draftCount}
        </span>
      )}
    </button>
    <button
      type="button"
      onClick={() => onSelect('kvalitet')}
      className={tabClass(active === 'kvalitet')}
    >
      <Gavel className="h-4 w-4" />
      Kvalitet
    </button>
  </div>
);
